import { PublicBidStatus, SourcingEventStatus } from "../../../autogen/bff-api";

// Once a sourcing event reaches an award decision, a bid that is still merely
// SUBMITTED was not selected for award — but it was not rejected either, and its
// evaluation score is preserved. Rejection (avvisning) stays a separate, deliberate act.
export type BidOutcome =
  | "draft"
  | "submitted"
  | "awarded"
  | "notSelected"
  | "rejected";

const AWARD_DECIDED_EVENT_STATUSES: SourcingEventStatus[] = [
  SourcingEventStatus.AwardDecision,
  SourcingEventStatus.Awarded,
];

export const isEventAwarded = (
  eventStatus: SourcingEventStatus | undefined,
): boolean =>
  eventStatus != null && AWARD_DECIDED_EVENT_STATUSES.includes(eventStatus);

// The award marks winning bids AWARDED, so a present AWARDED bid is a reliable
// signal that the decision has been made — for views that hold the bid set but
// not the event status (e.g. the bid-detail page).
export const isAwardDecided = (
  bids: { status: PublicBidStatus }[] | undefined,
): boolean => bids?.some((b) => b.status === PublicBidStatus.Awarded) ?? false;

export const deriveBidOutcome = (
  bidStatus: PublicBidStatus,
  awardDecided: boolean,
): BidOutcome => {
  if (bidStatus === PublicBidStatus.Rejected) return "rejected";
  if (bidStatus === PublicBidStatus.Awarded) return "awarded";
  if (bidStatus === PublicBidStatus.Draft) return "draft";
  return awardDecided ? "notSelected" : "submitted";
};
